import { STATUS_TYPES } from 'utils/constants';

export const defaultValues = {
  is_active: STATUS_TYPES.ACTIVE,
};

export const PANEL_TYPES = {
  RECRUITMENTVN: 'recruitment_vn',
  RECRUITMENTEN: 'recruitment_en',
};


export const EMPLOYMENT_TYPE = {
  FULL_TIME: 1,   // Toàn thời gian
  PART_TIME: 2,   // Bán thời gian
  CONTRACT: 3,    // Hợp đồng
  INTERN: 4,      // Thực tập
};

export const EmploymentTypeOpts = [
  { value: EMPLOYMENT_TYPE.FULL_TIME, label: 'Toàn thời gian' },
  { value: EMPLOYMENT_TYPE.PART_TIME, label: 'Bán thời gian' },
  { value: EMPLOYMENT_TYPE.CONTRACT, label: 'Hợp đồng' },
  { value: EMPLOYMENT_TYPE.INTERN, label: 'Thực tập' },
];